import { Component, Inject, OnInit } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-media-description-dialog',
	standalone: true,
	imports: [
		MaterialModule,
		PipesModule,
		CommonModule,
		FormsModule
	],
	templateUrl: './media-description-dialog.component.html',
	styleUrl: './media-description-dialog.component.scss'
})
export class MediaDescriptionDialogComponent implements OnInit {

	private originalDescription: string = null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public description: string,
		private matDialogRef: MatDialogRef<MediaDescriptionDialogComponent>
	) {}

	ngOnInit(): void {
		this.originalDescription = this.description;
	}

	close(): void {
		this.matDialogRef.close(this.originalDescription);
	}

	save(): void {
		this.matDialogRef.close(this.description);
	}

}
